import { useQuery } from "@tanstack/react-query";
import { getLeatStatus } from "../../api/bLeatApi";

export const useGetLeatStatus = (organisationId, enabled = true) => {
  return useQuery({
    queryKey: ["leat-status", organisationId],
    queryFn: () => getLeatStatus(organisationId),
    enabled: !!organisationId && enabled,
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: true,
    onError: (error) => {
      console.error("Error fetching Leat status:", error.response || error);
    },
  });
};
